import { ICexPair, IDexPair } from 'types/pairs';

import {
  arbitrageArbitragesHistoryFiltersScheme,
  arbitrageBalancerListFiltersScheme,
  arbitrageTradeHistoryFiltersScheme,
} from './arbitrage';
import { cexPairOrdersFiltersScheme, cexPairTradesFiltersScheme } from './cex_pair';
import { IFilterValue } from './common';
import {
  dexBoostHoldersWalletsFiltersScheme,
  dexBuyAndSellWalletsFiltersScheme,
  dexPairConnectWalletsFiltersScheme,
  dexPairSwapsFiltersScheme,
  dexPairTransactionsFiltersScheme,
  dexPairWalletsFiltersScheme,
} from './dex_pair';
import { solPairSwapsFiltersScheme, solPairWalletsFiltersScheme } from './sol_pair';

export enum EDexPairFilters {
  wallets = 'wallets',
  walletsTransfer = 'walletsTransfer',
  boostHoldersWallets = 'boostHoldersWallets',
  buyAndSellWallets = 'buyAndSellWallets',
  transactions = 'transactions',
  connectWallets = 'connectWallets',
  swaps = 'swaps',
}

export enum ESolPairFilters {
  wallets = 'wallets',
  // transactions = 'transactions',
  // connectWallets = 'connectWallets',
  swaps = 'swaps',
}

export enum ECexPairFilters {
  orders = 'orders',
  trades = 'trades',
}

export enum EGeneralFilters {
  wallets = 'wallets',
  accounts = 'accounts',
}

export enum EArbitrageFilters {
  balancer_list = 'balancer_list',
  arbitrages_history = 'arbitrages_history',
  trades_history = 'trades_history',
}

export { projectFiltersScheme } from './project';
export { EProjectFilters } from './project/types';

export const dexPairFiltersScheme = ({
  pair,
  type,
  isAdmin,
}: {
  pair: IDexPair | undefined;
  type: EDexPairFilters;
  isAdmin?: boolean;
}) => {
  return pair
    ? {
        [EDexPairFilters.wallets]: dexPairWalletsFiltersScheme(pair),
        [EDexPairFilters.walletsTransfer]: dexPairWalletsFiltersScheme(pair),
        [EDexPairFilters.boostHoldersWallets]: dexBoostHoldersWalletsFiltersScheme(pair),
        [EDexPairFilters.transactions]: dexPairTransactionsFiltersScheme(pair, { isAdmin }),
        [EDexPairFilters.buyAndSellWallets]: dexBuyAndSellWalletsFiltersScheme(pair),
        [EDexPairFilters.connectWallets]: dexPairConnectWalletsFiltersScheme(), //pair
        [EDexPairFilters.swaps]: dexPairSwapsFiltersScheme(),
      }[type]
    : undefined;
};

export const solPairFiltersScheme = ({
  pair,
  type,
}: {
  pair: IDexPair | undefined;
  type: ESolPairFilters;
}) => {
  return pair
    ? {
        [ESolPairFilters.wallets]: solPairWalletsFiltersScheme(), // pair
        // [EDexPairFilters.boostHoldersWallets]: dexBoostHoldersWalletsFiltersScheme(pair),
        // [ESolPairFilters.transactions]: dexPairTransactionsFiltersScheme(pair),
        // [ESolPairFilters.connectWallets]: dexPairConnectWalletsFiltersScheme(pair),
        [ESolPairFilters.swaps]: solPairSwapsFiltersScheme(),
      }[type]
    : undefined;
};

export const cexPairFiltersScheme = ({
  pair,
  type,
  isAdmin,
}: {
  pair: ICexPair | undefined;
  type: ECexPairFilters;
  isAdmin?: boolean;
}) => {
  return pair
    ? {
        [ECexPairFilters.orders]: cexPairOrdersFiltersScheme({ isAdmin }),
        [ECexPairFilters.trades]: cexPairTradesFiltersScheme(),
      }[type]
    : undefined;
};

export const arbitrageFiltersSheme = ({ arbitrage }: { arbitrage: EArbitrageFilters }) => {
  return (
    {
      [EArbitrageFilters.balancer_list]: arbitrageBalancerListFiltersScheme(),
      [EArbitrageFilters.arbitrages_history]: arbitrageArbitragesHistoryFiltersScheme(),
      [EArbitrageFilters.trades_history]: arbitrageTradeHistoryFiltersScheme(),
    }[arbitrage] ?? undefined
  );
};

export { generalWalletsFiltersScheme } from './general/wallets';

type IPairId = number;

export type IDexPairsFilters = Record<
  IPairId,
  | {
      updated_at: string;
      filters: {
        [key in EDexPairFilters]: {
          filters: IFilterValue[];
          setted: IFilterValue[];
        };
      };
    }
  | undefined
>;

export type ISolPairsFilters = Record<
  IPairId,
  | {
      updated_at: string;
      filters: {
        [key in ESolPairFilters]: {
          filters: IFilterValue[];
          setted: IFilterValue[];
        };
      };
    }
  | undefined
>;

export type ICexPairsFilters = Record<
  IPairId,
  | {
      updated_at: string;
      filters: {
        [key in ECexPairFilters]: {
          filters: IFilterValue[];
          setted: IFilterValue[];
        };
      };
    }
  | undefined
>;

export type IArbitrageFilters = Record<
  EArbitrageFilters,
  { filters?: IFilterValue[]; setted?: IFilterValue[] }
>;

export type IProjectFilters = Record<
  string,
  | {
      updated_at: string;
      filters: IFilterValue[];
      setted: IFilterValue[];
    }
  | undefined
>;

export type IFilters = {
  dex: IDexPairsFilters;
  cex: ICexPairsFilters;
  sol: ISolPairsFilters;
  project: IProjectFilters;
  [EGeneralFilters.wallets]: { filters?: IFilterValue[]; setted?: IFilterValue[] };
  [EGeneralFilters.accounts]: { filters?: IFilterValue[]; setted?: IFilterValue[] };
  arbitrage: IArbitrageFilters;
};
